import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { AuthService } from '@app/shared/auth/auth.service';
import { environment } from '@env/environment';

@Injectable()
export class RegisteredGuard implements CanActivate {
  constructor(private readonly authService: AuthService) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    if (!this.authService.isOnboarded) {
      window.location.href = `${environment.sweetDashboardAppUrl}/onboarding/verify-email?ref=benchmarks`;
      return false;
    } else {
      return true;
    }
  }
}
